Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _getComponentName = require('airbnb-prop-types/build/helpers/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function iconProp(props, propName, componentName) {
  var propValue = props[propName];
  if (propValue == null || propValue === false) {
    return null;
  }

  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  var elementError = _propTypes.element.apply(undefined, [props, propName, componentName].concat(rest));
  if (elementError) {
    return elementError;
  }

  var name = (0, _getComponentName2['default'])(propValue.type);
  if (!name.startsWith('Icon') && name !== 'AnIcon' && name !== 'ActiveChevron' && !name.startsWith('withDirection(IconWithDirection')) {
    return new Error(String(componentName) + '.' + String(propName) + ' does not appear to be an Icon component');
  }

  return null;
}

iconProp.isRequired = function (props, propName, componentName) {
  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    rest[_key2 - 3] = arguments[_key2];
  }

  var propValue = props[propName];
  if (propValue == null || propValue === false) {
    return new TypeError('Required prop `' + String(propName) + '` was not specified in `' + String(componentName) + '`.');
  }
  return iconProp.apply(undefined, [props, propName, componentName].concat(rest));
};

exports['default'] = iconProp;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/iconProp.js
// module id = 254
// module chunks = 168707334958949